import { useBankProfile } from '@contexts/BankProfileContext';
import { useAuth } from '@hooks/useAuth';
import { useQuery } from '@tanstack/react-query';
import axios from 'axios';

export interface CompanyDataResponse {
	company_name: string;
	registration_number: string;
	address: {
		line: null | string;
		town: null | string;
		country: null | string;
		postal_code: null | string;
		building_number: null | string;
	};
}

export const useCompanyDetails = () => {
	const { session } = useAuth();
	const { selectedProfile, isPersonal } = useBankProfile();

	const fetchCompanyDetails = async (): Promise<CompanyDataResponse> => {
		const response = await axios.get(
			`${import.meta.env.VITE_API_HOST}/api/v1/profiles/${selectedProfile.id}/business-details`,
			{
				headers: { Authorization: session?.tokenized },
			},
		);

		return response.data;
	};

	return useQuery({
		queryKey: ['company-data', selectedProfile?.id],
		queryFn: fetchCompanyDetails,
		enabled: !!selectedProfile?.id && !isPersonal,
		refetchOnWindowFocus: false,
	});
};
